var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewV2(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99935 1.33333C10.526 1.33333 12.7793 2.75333 13.8793 5C12.7793 7.24667 10.5327 8.66667 7.99935 8.66667C5.46602 8.66667 3.21935 7.24667 2.11935 5C3.21935 2.75333 5.47268 1.33333 7.99935 1.33333ZM7.99935 0C4.66602 0 1.81935 2.07333 0.666016 5C1.81935 7.92667 4.66602 10 7.99935 10C11.3327 10 14.1793 7.92667 15.3327 5C14.1793 2.07333 11.3327 0 7.99935 0ZM7.99935 3.33333C8.91935 3.33333 9.66601 4.08 9.66601 5C9.66601 5.92 8.91935 6.66667 7.99935 6.66667C7.07935 6.66667 6.33268 5.92 6.33268 5C6.33268 4.08 7.07935 3.33333 7.99935 3.33333ZM7.99935 2C6.34602 2 4.99935 3.34667 4.99935 5C4.99935 6.65333 6.34602 8 7.99935 8C9.65268 8 10.9993 6.65333 10.9993 5C10.9993 3.34667 9.65268 2 7.99935 2Z",
    fill: "#BBBBBB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewV2);
export default __webpack_public_path__ + "static/media/ViewV2.02d9197c04eb882f0d648f22c9241985.svg";
export { ForwardRef as ReactComponent };